var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":"","visible":_vm.visible,"width":"30%","append-to-body":"","top":"5vh"},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('f-select',{attrs:{"list":_vm.list,"value":_vm.key},on:{"submit":_vm.handleSubmit,"update:value":function($event){_vm.key=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }